"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { Calendar, MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locations = [{
  id: "artigas",
  city: "Artigas",
  date: "Próximo inicio: 10 de Marzo",
  x: 32.5,
  y: 8.8
}, {
  id: "salto",
  city: "Salto",
  date: "Próximo inicio: 15 de Marzo",
  x: 15,
  y: 26.6
}, {
  id: "paysandu",
  city: "Paysandú",
  date: "Próximo inicio: 20 de Marzo",
  x: 12.5,
  y: 40
}, {
  id: "rivera",
  city: "Rivera",
  date: "Próximo inicio: 05 de Abril",
  x: 62.5,
  y: 13.3
}, {
  id: "tacuarembo",
  city: "Tacuarembó",
  date: "Próximo inicio: 10 de Abril",
  x: 45,
  y: 33.3
}, {
  id: "melo",
  city: "Melo",
  date: "Próximo inicio: 12 de Marzo",
  x: 75,
  y: 35.5
}, {
  id: "mercedes",
  city: "Mercedes",
  date: "Próximo inicio: 25 de Marzo",
  x: 15,
  y: 57.7
}, {
  id: "durazno",
  city: "Durazno",
  date: "Próximo inicio: 18 de Abril",
  x: 45,
  y: 53.3
}, {
  id: "florida",
  city: "Florida",
  date: "Próximo inicio: 22 de Marzo",
  x: 47.5,
  y: 66.6
}, {
  id: "minas",
  city: "Minas",
  date: "Próximo inicio: 02 de Mayo",
  x: 65,
  y: 71.1
}, {
  id: "rocha",
  city: "Rocha",
  date: "Próximo inicio: 28 de Marzo",
  x: 82.5,
  y: 66.6
}, {
  id: "maldonado",
  city: "Maldonado",
  date: "Próximo inicio: 15 de Abril",
  x: 70,
  y: 84.4
}, {
  id: "colonia",
  city: "Colonia",
  date: "Próximo inicio: 08 de Abril",
  x: 22.5,
  y: 75.5
}, {
  id: "sanjose",
  city: "San José",
  date: "Próximo inicio: 12 de Abril",
  x: 37.5,
  y: 77.7
}];
export default function PresenciaNacional() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  return <section id="presencia-nacional" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`bg-slate-950 rounded-3xl p-8 md:p-12 lg:p-16 border border-slate-800 shadow-2xl relative overflow-hidden transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
            <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
            <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-secondary/10 blur-[120px]" />
            <div className="absolute inset-0 opacity-[0.03]" style={{
            backgroundImage: "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
            backgroundSize: "32px 32px"
          }} />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
            {}
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-slate-800 text-secondary text-sm font-medium">
                <Navigation className="w-4 h-4" />
                <span>Alcance Nacional</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">
                Llevamos la capacitación a{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-primary">
                  todo el interior
                </span>
              </h2>
              <p className="text-slate-400 text-lg leading-relaxed max-w-xl">
                ECAP escuela de capacitaciones privadas cuenta con una amplia
                trayectoria dictando clases presenciales en diversas localidades
                de Uruguay. Acercamos oportunidades de formación técnica y
                profesional directamente a tu ciudad.
              </p>
              <div className="pt-4 flex flex-wrap gap-4">
                <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-4 flex-1 min-w-[140px]">
                  <div className="text-3xl font-bold text-white mb-1">+10</div>
                  <div className="text-sm text-slate-400">Años de experiencia</div>
                </div>
                <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-4 flex-1 min-w-[140px]">
                  <div className="text-3xl font-bold text-white mb-1">15+</div>
                  <div className="text-sm text-slate-400">Ciudades alcanzadas</div>
                </div>
              </div>
            </div>

            {}
            <div className="relative w-full max-w-md mx-auto aspect-[4/4.5] flex items-center justify-center">
              {}
              <svg viewBox="0 0 400 450" className="absolute inset-0 w-full h-full drop-shadow-2xl" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M130,20 C180,30 250,50 280,80 C320,120 360,200 350,280 C340,320 280,380 200,400 C150,410 100,380 80,350 C50,300 30,250 40,200 C50,150 80,80 130,20 Z" className="fill-slate-900 stroke-slate-800" strokeWidth="3" strokeLinejoin="round" />
                {}
                <path d="M130,20 C180,30 250,50 280,80 C320,120 360,200 350,280 C340,320 280,380 200,400 C150,410 100,380 80,350 C50,300 30,250 40,200 C50,150 80,80 130,20 Z" className="fill-transparent stroke-slate-800/50" strokeWidth="1" strokeDasharray="4 4" transform="scale(0.95) translate(10, 10)" />
              </svg>

              {}
              {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-20" style={{
              left: `${loc.x}%`,
              top: `${loc.y}%`,
              transform: "translate(-50%, -50%)"
            }}>
                  <Popover open={hoveredId === loc.id} onOpenChange={open => {
                if (!open) setHoveredId(null);
              }}>
                    <PopoverTrigger asChild>
                      <div className="relative flex items-center justify-center cursor-pointer group" onMouseEnter={() => setHoveredId(loc.id)} onMouseLeave={() => setHoveredId(null)}>
                        <span className="absolute inline-flex h-6 w-6 animate-ping rounded-full bg-secondary opacity-40 group-hover:opacity-75 transition-opacity duration-300"></span>
                        <Button variant="ghost" size="icon" className="relative inline-flex rounded-full h-3 w-3 p-0 min-w-0 bg-secondary hover:bg-secondary hover:scale-150 transition-transform duration-300 shadow-[0_0_10px_rgba(var(--secondary),0.8)]" aria-label={`Ver información de ${loc.city}`} />
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-3 bg-popover/95 backdrop-blur-sm border-border shadow-xl" sideOffset={10} onMouseEnter={() => setHoveredId(loc.id)} onMouseLeave={() => setHoveredId(null)}>
                      <div className="space-y-1.5">
                        <h4 className="font-bold text-sm flex items-center gap-1.5 text-foreground">
                          <MapPin className="w-3.5 h-3.5 text-primary" />
                          {loc.city}
                        </h4>
                        <p className="text-xs text-muted-foreground flex items-center gap-1.5 font-medium">
                          <SafeHydrate><Calendar className="w-3 h-3" /></SafeHydrate>
                          {loc.date}
                        </p>
                      </div>
                    </PopoverContent>
                  </Popover>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}